import { Component, Input } from '@angular/core';
import { IconV3Component } from '@gea/digital-ui-lib';
import { ApiService } from 'src/app/shared/services/api.service';
import { TooltipModule } from 'primeng/tooltip';
import { ApplicationFeature } from 'src/app/shared/data/application-feature';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'permissions-icons-renderer',
  template: `
    <span style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
      @if (featuresList.length > 0) {
        @for (feature of featuresList; track feature) {
          @if (feature === 'Feedback') {
            <geaui-icon-v3
              [file]="iconNames[feature]"
              [fileSize]="16"
              [pTooltip]="isCustomRole ? feature + ' - Custom Access' : feature"
              [appName]="'hrt/connect'"
              [color]="isCustomRole ? 'tertiary-red' : 'dark-blue'"
            ></geaui-icon-v3>
          } @else {
            <geaui-icon-v3
              [file]="iconNames[feature]"
              [fileSize]="16"
              [pTooltip]="feature"
            ></geaui-icon-v3>
          }
        }
      }
    </span>
  `,
  standalone: true,
  imports: [TooltipModule, IconV3Component, SkeletonModule],
})
export class PermissionsIconsRenderer {
  constructor(private api: ApiService) {}
  @Input() rowData: any;

  featuresList: string[] = [];
  isCustomRole: boolean = false;
  iconNames: Record<string, string> = {
    Home: 'home',
    Dashboard: 'grid-interface',
    Users: 'multiple',
    Sites: 'factory',
    Assets: 'playlist',
    OrderStatus: 'progress',
    Tools: 'measurement',
    Parts: 'wrench-tool',
    Bookmark: 'bookmark',
    Documents: 'book',
    Feedback: 'b-comment',
    Config: 'settings-gear',
    MasterSchedule: 'calendar',
    Projects: 'folder',
  };

  ngOnInit(): void {
    if (this.rowData?.Permissions) {
      // Parse the permissions string format: "featureId|CanView|CanEdit|CustomPerm"
      const permissionEntries = this.rowData.Permissions.split(',').map(
        (entry: string) => entry.trim(),
      );

      this.featuresList = permissionEntries
        .map((entry: string) => {
          const parts = entry.split('|');
          if (parts.length >= 4) {
            const featureId = parseInt(parts[0]);
            const canView = parts[1] === 'true';
            const canEdit = parts[2] === 'true';
            const customPerm = parts[3] === 'true';

            // Check if user can view this feature
            if (canView) {
              // Check for custom permission on Feedback feature
              if (featureId === ApplicationFeature.Feedback && customPerm) {
                this.isCustomRole = true;
              }

              // Map feature ID to feature name
              return ApplicationFeature[featureId];
            }
          }
          return null;
        })
        .filter(
          (feature: string | null) => feature !== null && feature !== undefined,
        ) // Remove null values
        .filter(
          (feature: string) =>
            feature !== 'Home' && // excluding home as it is default
            feature !== 'Companies' &&
            feature !== 'Proposals' &&
            feature !== 'Products' &&
            feature !== 'EngineeringData' &&
            feature !== 'AdminPage',
        ); // Excluding features not present in sidebar menu
    }
  }
}
